import React, { Component } from "react"
import { withStyles } 		from "material-ui/styles"
import Button 				from 'material-ui/Button'
import { Link } 			from 'react-router-dom'

const styles = {
	navigation: {
		margin: "-2rem",
		marginBottom: "1rem",
		padding: "1rem",
		borderBottom: "1px solid rgba(224, 224, 224, 1)"
	}
};

class SettingsNav extends Component {
	classes = this.props.classes;
	links = [
		{
			name: "currency",
			path: "/admin/settings/currency",
			show: true
		},
		{
			name: "countries",
			path: "/admin/settings/countries",
			show: true
		},
		{
			name: "school-types",
			path: "/admin/settings/school-types",
			show: true
		}
	];

	render() {
		return (
			<nav className={this.classes.navigation}>
				{this.links.map((link, index) => {
					if (link.show) {
						return (
							<Button
								color="primary"
								component={Link}
								key={index}
								to={link.path}>
								{link.name}
							</Button>
						);
					}
				})}
			</nav>
		);
	}
}

export default withStyles(styles)(SettingsNav);



// WEBPACK FOOTER //
// ./src/components/navigation/SettingsNav.js